export const data = [
 {
    id: 1,
    title: "Cloud Architect",
    description: "Seeking a Cloud Architect adept at designing, building, and optimizing cloud solutions, collaborating with teams to define standards, develop cloud-native apps, and implement DevOps best practices.",
    experience: 7,
    row:1,
    location: "Helsingborg, Göteborg",
    breif: [
        {
            description: "As a Cloud Architect, you will be responsible for designing, building, and optimizing our cloud-based solutions to meet the needs of our clients and stakeholders. You will work closely with cross-functional teams to define architecture standards, develop cloud-native applications, and implement DevOps best practices. The ideal candidate will have a strong background in both software development and DevOps engineering, with expertise in cloud technologies."
        }
    ],
    requirement: [
        {
            detail: "Master's degree or equivalent combination of education and work experience"
        },
        {
            detail: "Experience working with business development"
        },
        {
            detail: "A mix of total 7+ years of experience in software development, with a strong focus on cloud-native application development and in DevOps engineering, with expertise in CI/CD pipelines, infrastructure as code (IaC), and automation tools (Terraform / CloudFormation)."
        },
        {
            detail: "Hands-on experience with cloud platforms such as AWS, Azure, or GCP, including proficiency in cloud services and management tools."
        },
        {
            detail: "Strong programming skills in languages such as Python, Ruby, Java, Shell scripting (Bash) or Node.js, and experience with modern development frameworks and tools."
        },
        {
            detail: "Experience with containerization and orchestration technologies such as Docker, Kubernetes, Amazon ECS and Helm."
        },
        {
            detail: "Experience with monitoring tools like Prometheus, Grafana, or Nagios for monitoring system metrics and performance and logging tools like ELK stack (Elasticsearch, Logstash, Kibana), Splunk, or Sumo Logic for collecting and analyzing log data."
        },
        {
            detail: "Solid understanding of DevOps practices, including continuous integration, continuous delivery, and infrastructure automation."
        },
        {
            detail: "Maven, Jenkins, Bamboo, GitLab, GitFlow, GitHub flow."
        },
        {
            detail: "Knowledge of SQL and NoSQL databases like MySQL, PostgreSQL, MongoDB, or Redis."
        },
        {
            detail: "Event-driven architecture, CQRS and event-sourcing design-pattern, DDD and microservices architecture"
        },
        {
            detail: "Knowledge of cloud security principles, best practices, encryption, authentication, and access control mechanisms and compliance frameworks (e.g., CIS benchmarks, GDPR, HIPAA)."
        },
        {
            detail: "Excellent problem-solving skills and the ability to troubleshoot complex issues in cloud environments."
        },
        {
            detail: "Strong communication and collaboration skills, with the ability to work effectively in a cross-functional team environment."
        }
    ],
    responsibilityDesc: [
        {
            description: "You will be responsible for new development activities in the area and a key resource to drive the applications and the business forward."
        }
    ],
    responsibilities: [
        {
            detail: "Design and architect cloud-based solutions that are scalable, reliable, and secure, leveraging cloud services and technologies such as AWS, Azure, or Google Cloud Platform (GCP)."
        },
        {
            detail: "Develop and implement cloud-native applications using modern development frameworks and methodologies, such as microservices architecture, serverless computing, and containerization (e.g., Docker, Kubernetes)."
        },
        {
            detail: "Collaborate with software development teams to ensure applications are designed with cloud principles in mind, including elasticity, resiliency, and scalability."
        },
        {
            detail: "Implement DevOps practices and tools to automate and streamline the deployment, testing, and monitoring of cloud-based applications and infrastructure."
        },
        {
            detail: "Design and implement CI/CD pipelines using tools such as Jenkins, GitLab CI/CD, or Azure DevOps."
        },
        {
            detail: "Define and enforce cloud security policies, best practices, and compliance requirements, including identity and access management (IAM), encryption, and network security."
        },
        {
            detail: "Optimize cloud costs and resource utilization through effective resource management, monitoring, and performance tuning."
        },
        {
            detail: "Provide technical leadership and guidance to development teams on cloud architecture, best practices, and emerging technologies."
        },
        {
            detail: "Stay updated on emerging technologies and industry trends and evaluate their potential impact on our software solutions."
        }
    ],
    profile: [
        {
            detail: "Proactivity, thinking one step ahead, raise potential issues and suggest solutions"
        },
        {
            detail: "Good interpersonal skills and a team player"
        },
        {
            detail: "Good communicating skills, including a high level in spoken and written English"
        },
        {
            detail: "Flexible and able to adapt quickly to changing business requirements"
        },
        {
            detail: "Innovative - See possible solutions to the impossible"
        },
        {
            detail: "Structured way of working"
        },
        {
            detail: "Strong business orientation - Service minded"
        }
    ]
},
{
    id: 2,
    title: "Senior Data Engineer",
    description: "Seeking a Senior Data Engineer with a software development background to design, build, and maintain scalable data pipelines and systems, ensuring data accuracy, reliability, and accessibility for analytical purposes.",
    experience: 6,
    row: 1,
    location: "Helsingborg, Göteborg",
    breif: [
      {
        description: "As a Senior Data Engineer, you will be responsible for designing, building, and maintaining scalable and robust data pipelines and systems. Leveraging your experience as both a data engineer and a software developer, you will work closely with cross-functional teams to extract, transform, and load data from various sources, ensuring its accuracy, reliability, and accessibility for analytical purposes. The ideal candidate will have a strong background in data engineering, with previous experience as a software developer. Your contributions will play a crucial role in propelling both our applications and our business forward."
      }
    ],
    requirement: [
      {
        detail: "Master's degree or equivalent combination of education and work experience."
      },
      {
        detail: "6+ years of experience in software development, with at least 3 years of experience specifically as a data engineer."
      },
      {
        detail: "Proven experience designing and building data pipelines and ETL processes."
      },
      {
        detail: "Experience with popular ML/DL frameworks & libraries such as Pandas, NumPy, TensorFlow/Keras, PyTorch, scikit-learn, Matplotlib, and Seaborn is valuable."
      },
      {
        detail: "Strong programming skills in languages such as Python, Java, R, Scala or Kotlin (JDK)."
      },
      {
        detail: "Experience with distributed data processing frameworks such as Apache Spark or Apache Flink."
      },
      {
        detail: "Solid understanding of relational & no-relational databases, and data warehousing concepts (e.g., SQL, NoSQL)."
      },
      {
        detail: "Strong understanding of machine learning (ML) and deep learning (DL) concepts and algorithms."
      },
      {
        detail: "Experience in backend engineering and REST API design using GraphQL."
      },
      {
        detail: "Experience in containerization with Docker, model serving with frameworks like TensorFlow Serving and FastAPI."
      },
      {
        detail: "Experience with cloud platforms and services (e.g., AWS, Azure, GCP) and serverless architecture."
      },
      {
        detail: "Hands-on experience with Data Lake, Databricks, Data Factory etc."
      },
      {
        detail: "Knowledge of big data technologies such as Hadoop, Hive, or HBase is a plus."
      },
      {
        detail: "Excellent problem-solving skills and the ability to troubleshoot complex issues."
      },
      {
        detail: "Strong communication and collaboration skills, with the ability to work effectively in a cross-functional team environment."
      },
      {
        detail: "Experience with version control systems (e.g., Git) and CI/CD pipelines."
      },
      {
        detail: "Meritorious: experience with AI models & crafting projects using ML."
      }
    ],
    responsibilityDesc: [
      {
        description: "You will be responsible for new development activities in the area and a key resource to drive the applications and the business forward."
      }
    ],
    responsibilities: [
      {
        detail: "Collaborate with data scientists, analysts, and other stakeholders to understand data requirements and translate them into technical solutions."
      },
      {
        detail: "Design, develop, and maintain scalable and efficient data pipelines and ETL processes to support data ingestion, transformation, and storage."
      },
      {
        detail: "Design and optimize relational and non-relational databases and data models."
      },
      {
        detail: "Implement data processing and enrichment tasks using technologies such as Apache Spark, Apache Flink, or similar distributed processing frameworks."
      },
      {
        detail: "Design and optimize data models and schemas for efficient storage and retrieval in data warehouses and data lakes."
      },
      {
        detail: "Implement and maintain monitoring, logging, and alerting systems to ensure data pipeline reliability and performance."
      },
      {
        detail: "Conduct code reviews and contribute to the continuous improvement of development processes and best practices."
      },
      {
        detail: "Clear understanding of cloud services, distributed systems, DevOps, and CI / CD practices."
      },
      {
        detail: "Stay updated on emerging technologies and industry trends in data engineering and software development and evaluate their potential impact on our data solutions."
      }
    ],
    profile: [
      {
        detail: "Proactivity, thinking one step ahead, raises potential issues and suggests solutions."
      },
      {
        detail: "Good interpersonal skills and a team player."
      },
      {
        detail: "Good communicating skills, including a high level in spoken and written English."
      },
      {
        detail: "Flexible and able to adapt quickly to changing business requirements."
      },
      {
        detail: "Innovative - See possible solutions to the impossible."
      },
      {
        detail: "Structured way of working."
      },
      {
        detail: "Strong business orientation - Service minded."
      }
    ]
  },
  {
    id: 3,
    title: "Senior Full Stack .NET Software Engineer",
    description: "Seeking a Senior Full Stack .NET Software Engineer to create, enhance, and maintain top-notch software solutions, collaborating closely with diverse teams to deliver scalable and effective applications.",
    experience: 7,
    row: 2,
    location: "Helsingborg, Göteborg",
    breif: [
      {
        description: "We're on the lookout for talented and enthusiastic Software Engineers who are passionate about what they do and are constantly striving to grow. In this role, you'll be at the forefront of new development initiatives. Your core focus will be on creating, enhancing, and maintaining top-notch software solutions that cater to our clients' requirements. Collaboration is key, as you'll be working closely with diverse teams to ensure the delivery of scalable and effective software applications. Your contributions will play a crucial role in propelling both our applications and our business forward."
      }
    ],
    requirement: [
      {
        detail: "Master's degree or equivalent combination of education and work experience."
      },
      {
        detail: "Experience working with business development."
      },
      {
        detail: "7+ years of experience in software development, with a core focus on .NET development."
      },
      {
        detail: "Proven experience with backend technologies such as C#, ASP.NET Core, Node.js, Entity Framework, and RESTful APIs."
      },
      {
        detail: "Experience with frontend frameworks (e.g., React, Angular, Vue.js) and frontend technologies (HTML, CSS, JavaScript)."
      },
      {
        detail: "Strong understanding of software engineering principles, design patterns, and best practices."
      },
      {
        detail: "Excellent problem-solving skills and the ability to troubleshoot complex issues."
      },
      {
        detail: "Experience with relational & no-relational databases and database design."
      },
      {
        detail: "Experience with version control systems (e.g., Git) and CI/CD pipelines."
      },
      {
        detail: "Good experience working with any cloud platforms (e.g., Azure, AWS, GCP) and serverless architecture."
      },
      {
        detail: "Experience with microservices architecture."
      },
      {
        detail: "Meritorious: knowledge of UX/UI and experience with Go, Python, AI related technologies."
      }
    ],
    responsibilityDesc: [
      {
        description: "You will be responsible for new development activities in the area and a key resource to drive the applications and the business forward."
      }
    ],
    responsibilities: [
      {
        detail: "Collaborate with business partners and product owners, designers, and other engineers to define requirements, design solutions, and implement features, ensuring they are clear, concise, and technically feasible."
      },
      {
        detail: "Develop and maintain high-quality, reusable, and efficient code using .NET technologies (C#, ASP.NET Core, Entity Framework)."
      },
      {
        detail: "Design and implement user interfaces using modern frontend frameworks (e.g., React, Angular, Vue.js) and frontend technologies (HTML, CSS, JavaScript)."
      },
      {
        detail: "Implement and maintain RESTful APIs and web services using ASP.NET Web API or similar frameworks."
      },
      {
        detail: "Design and optimize relational and no-relational databases and data models."
      },
      {
        detail: "Optimize application performance and scalability through code refactoring, performance tuning, and caching strategies."
      },
      {
        detail: "Clear understanding of cloud services, distributed systems, DevOps, and CI / CD practices."
      },
      {
        detail: "Stay updated on emerging technologies and industry trends and evaluate their potential impact on our software solutions."
      }
    ],
    profile: [
      {
        detail: "Proactivity, thinking one step ahead, raise potential issues and suggest solutions."
      },
      {
        detail: "Good interpersonal skills and a team player."
      },
      {
        detail: "Good communicating skills, including a high level in spoken and written English."
      },
      {
        detail: "Flexible and able to adapt quickly to changing business requirements."
      },
      {
        detail: "Innovative - See possible solutions to the impossible."
      },
      {
        detail: "Structured way of working."
      },
      {
        detail: "Strong business orientation - Service minded."
      }
    ]
  },
  {
    id: 4,
    title: "Senior Full Stack JAVA Software Engineer",
    description: "Seeking a Senior Full Stack JAVA Software Engineer to lead new development initiatives and drive the creation, enhancement, and maintenance of top-notch software solutions, collaborating closely with diverse teams to deliver scalable and effective applications.",
    experience: 7,
    row: 2,
    location: "Helsingborg, Göteborg",
    breif: [
      {
        description: "We're on the lookout for talented and enthusiastic Software Engineers who are passionate about what they do and are constantly striving to grow. In this role, you'll be at the forefront of new development initiatives. Your core focus will be on creating, enhancing, and maintaining top-notch software solutions that cater to our clients' requirements. Collaboration is key, as you'll be working closely with diverse teams to ensure the delivery of scalable and effective software applications. Your contributions will play a crucial role in propelling both our applications and our business forward."
      }
    ],
    requirement: [
      {
        detail: "Master's degree or equivalent combination of education and work experience."
      },
      {
        detail: "Experience working with business development."
      },
      {
        detail: "Strong experience working as a JAVA or KOTLIN developer."
      },
      {
        detail: "Proven experience with back-end technologies such as: Spring Boot, Unit Testing, Hibernate"
      },
      {
        detail: "Spring Boot"
      },
      {
        detail: "Unit Testing"
      },
      {
        detail: "Hibernate"
      },
      {
        detail: "Maven, Git, Jenkins / Bamboo, GitHub"
      },
      {
        detail: "relational databases (e.g., MySQL, PostgreSQL) & NoSQL."
      },
      {
        detail: "Event-driven architecture, CQRS and event-sourcing design-pattern, DDD"
      },
      {
        detail: "Experience with front-end technologies such as HTML, CSS, JavaScript, and modern front-end frameworks (e.g., React, Angular, Vue.js), good to have but not mandatory."
      },
      {
        detail: "Strong understanding of software engineering principles, design patterns, and best practices."
      },
      {
        detail: "Excellent problem-solving skills and the ability to troubleshoot complex issues."
      },
      {
        detail: "Strong communication skills and the ability to work effectively in a collaborative team environment."
      },
      {
        detail: "Hands-on experience with cloud platforms (e.g., AWS, Azure, Google Cloud) and containerization technologies (e.g., Docker, Kubernetes)."
      },
      {
        detail: "Knowledge of Axon Framework"
      },
      {
        detail: "Knowledge of Apache Camel"
      },
      {
        detail: "Knowledge of Red Hat Enterprise Linux"
      },
      {
        detail: "Knowledge of cloud serverless architecture"
      },
      {
        detail: "Knowledge of microservices architecture"
      },
      {
        detail: "Meritorious: AI related technologies"
      }
    ],
    responsibilityDesc: [
      {
        description: "You will be responsible for new development activities in the area and a key resource to drive the applications and the business forward."
      }
    ],
    responsibilities: [
      {
        detail: "Collaborate with business partners and product owners, designers, and other engineers to define requirements, design solutions, and implement features, ensuring they are clear, concise, and technically feasible."
      },
      {
        detail: "Translate product requirements into innovative solutions that provide an excellent client experience and align with architectural roadmap."
      },
      {
        detail: "Performs and / or leads design, coding, testing, implementation, and documentation of solution."
      },
      {
        detail: "Design and implement user interfaces using modern front-end frameworks (e.g., React, Angular, Vue.js)."
      },
      {
        detail: "Implement and maintain RESTful APIs and web services."
      },
      {
        detail: "Optimize application performance and scalability through code refactoring, performance tuning, and caching strategies."
      },
      {
        detail: "Clear understanding of cloud services, distributed systems, DevOps, and CI / CD practices."
      },
      {
        detail: "Stay updated on emerging technologies and industry trends and evaluate their potential impact on our software solutions."
      }
    ],
    profile: [
      {
        detail: "Proactivity, thinking one step ahead, raise potential issues and suggest solutions."
      },
      {
        detail: "Good interpersonal skills and a team player."
      },
      {
        detail: "Good communicating skills, including a high level in spoken and written English."
      },
      {
        detail: "Flexible and able to adapt quickly to changing business requirements."
      },
      {
        detail: "Innovative - See possible solutions to the impossible."
      },
      {
        detail: "Structured way of working."
      },
      {
        detail: "Strong business orientation - Service minded."
      }
    ]
  },
  {
    id: 5,
    title: "Senior Full Stack Web Developer with Python ",
    description: "Seeking a Software Engineer passionate about creating, enhancing, and maintaining top-tier software solutions, collaborating with diverse teams to deliver scalable applications, and driving development initiatives forward.",
    experience: 7,
    row:2,
    location: "Helsingborg, Göteborg",
    breif: [
        {
            description: "We're on the lookout for talented and enthusiastic Software Engineers who are passionate about what they do and are constantly striving to grow. In this role, you'll be at the forefront of new development initiatives. Your core focus will be on creating, enhancing, and maintaining top-notch software solutions that cater to our clients' requirements. Collaboration is key, as you'll be working closely with diverse teams to ensure the delivery of scalable and effective software applications. Your contributions will play a crucial role in propelling both our applications and our business forward. "}
    ],
   requirement: [
        {
            "detail": "Master's degree or equivalent combination of education and work experience"
        },
        {
            "detail": "Experience working with business development"
        },
        {
            "detail": "Experience working as a full stack web developer with PYTHON"
        },
        {
            "detail": "Experience with back-end technologies such as:"
        },
        {
            "detail": "Python: Advanced proficiency in Python and frameworks such as Django, Flask, or FastAPI."
        },
        {
            "detail": "Database Management: Experience with SQL databases (e.g., PostgreSQL, MySQL) and NoSQL databases (e.g., MongoDB)."
        },
        {
            "detail": "API Development: Expertise in building and consuming RESTful and GraphQL APIs."
        },
        {
            "detail": "Server Management: Familiarity with server-side technologies and deployment processes / containerization technologies (e.g., Docker, Kubernetes)."
        },
        {
            "detail": "ORMs like SQLalchemy"
        },
        {
            "detail": "Event-driven architecture, CQRS and event-sourcing design-pattern, DDD"
        },
        {
            "detail": "Proven experience with front-end technologies such as:"
        },
        {
            "detail": "JavaScript, TypeScript"
        },
        {
            "detail": "Frontend Frameworks (e.g., React, Vue.js, Svelte, SvelteKit)"
        },
        {
            "detail": "HTML5, CSS3, Responsive Web Design"
        },
        {
            "detail": "Module Bundlers (e.g., webpack, Parcel)"
        },
        {
            "detail": "RESTful APIs, GraphQL"
        },
        {
            "detail": "State Management (e.g., Redux, Vuex, Recoil)"
        },
        {
            "detail": "WebSockets"
        },
        {
            "detail": "Server-Side Rendering (SSR) and/or Static Site Generation (SSG) techniques for SPAs"
        },
        {
            "detail": "Proven experience with DevOps tools such as:"
        },
        {
            "detail": "Version Control: Proficient with Git and collaborative development workflows (GitFlow)."
        },
        {
            "detail": "CI/CD: Experience with continuous integration and deployment tools (e.g., Jenkins, CircleCI, GitLab CI)."
        },
        {
            "detail": "Testing: Knowledge of automated testing frameworks for both front-end and back-end (e.g., PyTest, Selenium, Jest)."
        },
        {
            "detail": "Cloud Platforms: Hands-on experience with cloud services like AWS, Google Cloud, or Azure & cloud serverless architecture."
        },
        {
            "detail": "Containerization: Experience with Docker and container orchestration."
        },
        {
            "detail": "Excellent problem-solving skills and the ability to troubleshoot complex issues."
        },
        {
            "detail": "Strong communication skills and the ability to work effectively in a collaborative team environment."
        },
        {
            "detail": "Knowledge of microservices architecture"
        },
        {
            "detail": "Meritorious: AI related technologies"
        }
    ],
    responsibilityDesc: [
        {
            description: "You will be responsible for new development activities in the area and a key resource to drive the applications and the business forward. "
        }
    ],
    responsibilities: [
        {
            "detail": "Collaborate with business partners and product owners, designers, and other engineers to define requirements, design solutions, and implement features, ensuring they are clear, concise, and technically feasible."
        },
        {
            "detail": "Translate product requirements into innovative solutions that provide an excellent client experience and align with architectural roadmap."
        },
        {
            "detail": "Perform and/or lead design, coding, testing, implementation, and documentation of solutions."
        },
        {
            "detail": "Design, develop, implement, and maintain high-quality web applications using Python and modern front-end frameworks (e.g., React, Angular, Vue.js)."
        },
        {
            "detail": "Implement and maintain RESTful APIs and web services."
        },
        {
            "detail": "Optimize application performance and scalability through code refactoring, performance tuning, and caching strategies."
        },
        {
            "detail": "Have a clear understanding of cloud services, distributed systems, DevOps, and CI/CD practices."
        },
        {
            "detail": "Stay updated on emerging technologies and industry trends and evaluate their potential impact on our software solutions."
        }
    ],
    profile: [
        {
            detail: "Proactivity, thinking one step ahead, raise potential issues and suggest solutions"
        },
        {
            detail: "Good interpersonal skills and a team player"
        },
        {
            detail: "Good communicating skills, including a high level in spoken and written English"
        },
        {
            detail: "Flexible and able to adapt quickly to changing business requirements"
        },
        {
            detail: "Innovative - See possible solutions to the impossible"
        },
        {
            detail: "Structured way of working"
        },
        {
            detail: "Strong business orientation - Service minded"
        }
    ]
},
{
    "id": 6,
    "title": "DevOps Engineer",
    "description": "Seeking a DevOps Engineer passionate about shaping software delivery processes, building and maintaining CI/CD pipelines, and collaborating with teams to deliver scalable and efficient solutions.",
    "experience": 5,
    "row": 2,
    "location": "Helsingborg, Göteborg",
    "breif": [
        {
            "description": "2MNordic is a Swedish IT consulting company, committed to helping clients re-engineer, digitalize, and optimize product development processes across industries. Our mission is to deliver outstanding results through collaboration, driving business growth and efficiency. We are looking for a talented and passionate DevOps Engineer to join our team and play a key role in shaping software delivery processes."
        }
    ],
    "requirement": [
        {
            "detail": "5+ years of hands-on experience in a DevOps role"
        },
        {
            "detail": "Proficiency in using tools like Jenkins, GitLab CI, or CircleCI for CI/CD pipelines"
        },
        {
            "detail": "Strong experience with cloud platforms like AWS, Azure, or Google Cloud"
        },
        {
            "detail": "Solid knowledge of Docker and Kubernetes"
        },
        {
            "detail": "Skilled in scripting languages like Python, Bash, or Groovy"
        },
        {
            "detail": "Proficient in using Git and experience with collaborative development workflows"
        },
        {
            "detail": "Experience with Infrastructure as Code (IaC) using tools like Terraform or CloudFormation"
        },
        {
            "detail": "Understanding of Agile development and DevOps methodologies"
        }
    ],
    "responsibilityDesc": [
        {
            "description": "As a DevOps Engineer, you will be responsible for building and maintaining CI/CD pipelines, automating infrastructure, and optimizing the development lifecycle. Your focus will be on implementing scalable solutions that support continuous integration and delivery."
        }
    ],
    "responsibilities": [
        {
            "detail": "Design, implement, and manage scalable CI/CD pipelines to automate software deployment processes"
        },
        {
            "detail": "Collaborate with software engineers, QA teams, and other stakeholders to streamline development and deployment practices"
        },
        {
            "detail": "Monitor and optimize system performance, ensuring high availability and reliability of services"
        },
        {
            "detail": "Develop and maintain infrastructure as code (IaC) using Terraform or CloudFormation"
        },
        {
            "detail": "Implement containerization and orchestration solutions using Docker and Kubernetes"
        },
        {
            "detail": "Ensure security best practices are followed throughout the software delivery pipeline"
        },
        {
            "detail": "Troubleshoot and resolve issues related to DevOps processes and environments"
        }
    ],
    "profile": [
        {
            "detail": "Proactive problem solver with a passion for innovative solutions"
        },
        {
            "detail": "Strong communicator with excellent collaboration skills"
        },
        {
            "detail": "Self-driven and motivated to continuously learn and stay updated with the latest DevOps trends"
        },
        {
            "detail": "Structured and organized with a focus on quality"
        }
    ]
}
];
